/** PDF.js can restore a stale page location while recalculating a preset. */
export function fitPdfPage(viewer, mode = "page-fit", page = viewer?.currentPageNumber) {
    if (!viewer) return;
    const validPage = Number.isInteger(page) && page > 0;
    if (validPage && viewer.currentPageNumber !== page) viewer.currentPageNumber = page;
    viewer.currentScaleValue = mode;
    if (validPage && viewer.currentPageNumber !== page) viewer.currentPageNumber = page;
}
